import script from "./SchemaGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaGroup.vue?vue&type=script&setup=true&lang=js"

import "./SchemaGroup.vue?vue&type=style&index=0&id=c4506e1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4506e1a"]])

export default __exports__